import React, { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Container,
    Box,
    IconButton,
    Menu,
    MenuItem,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { apps } from '../../data/appData';
import ThemeSelector from '../ThemeSelector/ThemeSelector';
import { ThemeContext } from '../../contexts/ThemeContext';
import './Header.scss';

const Header: React.FC = () => {
    const [mainMenuAnchorEl, setMainMenuAnchorEl] = React.useState<null | HTMLElement>(null);
    const [appsMenuAnchorEl, setAppsMenuAnchorEl] = React.useState<null | HTMLElement>(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { themeName } = useContext(ThemeContext);

    // Get the correct logo path based on theme
    const getLogoPath = () => {
        return themeName === 'Dark Mode' || themeName === 'Dark Teal' || themeName === 'Futuristic'
            ? "/images/planet-logo-dark.png"
            : "/images/planet-logo.png";

    };

    const handleMainMenu = (event: React.MouseEvent<HTMLElement>) => {
        setMainMenuAnchorEl(event.currentTarget);
    };

    const handleAppsMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAppsMenuAnchorEl(event.currentTarget);
    };

    const handleCloseMainMenu = () => {
        setMainMenuAnchorEl(null);
    };

    const handleCloseAppsMenu = () => {
        setAppsMenuAnchorEl(null);
    };

    return (
        <AppBar position="static">
            <Container maxWidth="lg">
                <Toolbar>
                    <Box
                        component={RouterLink}
                        to="/"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            color: 'white',
                            flexGrow: 1,
                        }}
                    >
                        <img
                            src={getLogoPath()}
                            alt="Planet B Logo"
                            className="header-logo"
                        />
                        <Typography
                            variant="h6"
                            component="span"
                            sx={{
                                ml: 1,
                                fontWeight: 700,
                            }}
                        >
                            Planet B
                        </Typography>
                    </Box>

                    {isMobile ? (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {/* <ThemeSelector /> */}
                            <IconButton
                                size="large"
                                edge="end"
                                color="inherit"
                                aria-label="menu"
                                onClick={handleMainMenu}
                                sx={{ ml: 1 }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={mainMenuAnchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(mainMenuAnchorEl)}
                                onClose={handleCloseMainMenu}
                            >
                                <MenuItem
                                    component={RouterLink}
                                    to="/"
                                    onClick={handleCloseMainMenu}
                                >
                                    Home
                                </MenuItem>
                                {apps.map((app) => (
                                    <MenuItem
                                        key={app.id}
                                        component={RouterLink}
                                        to={`/app/${app.id}`}
                                        onClick={handleCloseMainMenu}
                                    >
                                        {app.name}
                                    </MenuItem>
                                ))}
                                <MenuItem
                                    component={RouterLink}
                                    to="/about"
                                    onClick={handleCloseMainMenu}
                                >
                                    About Us
                                </MenuItem>
                                <MenuItem
                                    component={RouterLink}
                                    to="/contact"
                                    onClick={handleCloseMainMenu}
                                >
                                    Contact
                                </MenuItem>
                            </Menu>
                        </Box>
                    ) : (
                        <Box sx={{ display: 'flex' }}>
                            <Button color="inherit" component={RouterLink} to="/">
                                Home
                            </Button>

                            <Button
                                color="inherit"
                                endIcon={<KeyboardArrowDownIcon />}
                                onClick={handleAppsMenu}
                                aria-controls="apps-menu"
                                aria-haspopup="true"
                            >
                                Apps
                            </Button>
                            <Menu
                                id="apps-menu"
                                anchorEl={appsMenuAnchorEl}
                                keepMounted
                                open={Boolean(appsMenuAnchorEl)}
                                onClose={handleCloseAppsMenu}
                            >
                                {apps.map((app) => (
                                    <MenuItem
                                        key={app.id}
                                        component={RouterLink}
                                        to={`/app/${app.id}`}
                                        onClick={handleCloseAppsMenu}
                                    >
                                        {app.name}
                                    </MenuItem>
                                ))}
                            </Menu>

                            <Button
                                color="inherit"
                                component={RouterLink}
                                to="/about"
                            >
                                About Us
                            </Button>
                            <Button
                                color="inherit"
                                component={RouterLink}
                                to="/contact"
                            >
                                Contact
                            </Button>

                            {/* <ThemeSelector /> */}
                        </Box>
                    )}
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header; 